import * as React from "react";
import ImageTextCta, { ImageTextCtaProps } from "~/components/image-text-cta/image-text-cta";

export interface IImageTextCtaViewProps {
    contextModel: ImageTextCtaProps;
}

class ImageTextCtaView extends React.PureComponent<IImageTextCtaViewProps> {
    public render() {
        return <ImageTextCta {...this.props.contextModel} />;
    }
}

export default ImageTextCtaView;
